import React, { FC, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "ui-library/atoms";

import i18n from "core/i18n";
import { useGetContractChangeTabLink } from "core/hooks";
import { sentry } from "core/util";
import { changeSheetRecordApi } from "serverApi";

interface CancelRequestButtonProps {
    changeSheetId: string;
}

export const CancelRequestButton: FC<CancelRequestButtonProps> = ({ changeSheetId }) => {
    const { t } = i18n.useTranslation();
    const navigate = useNavigate();

    const { idObject } = useParams();
    const editTabUrl = useGetContractChangeTabLink(idObject);

    const onClick = useCallback(async () => {
        try {
            await changeSheetRecordApi.cancelChangeSheetRecord(idObject, changeSheetId);
        } catch (error) {
            sentry.error("Failed to cancel change sheet record:", error);
        } finally {
            navigate(editTabUrl, { replace: true });
        }
    }, [idObject, changeSheetId]);

    return (
        <Button variant="outlined" color="blue" onClick={onClick}>
            {t("change.cancelRequest")}
        </Button>
    );
};
